// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__gASEH","lanManagerListBody":"lanManagerListBody__7XBV7"};